const switchImg = {
    img: document.querySelectorAll('.jsSwitchImg') as NodeListOf<HTMLElement>,
    init(){
        this.setSwitch()
    },
    setSwitch(){
        this.img.forEach(item=>{
            const img = item.querySelector('img') as HTMLImageElement
            item.addEventListener('mouseenter', this.switchImage.bind(this, true, img))
            item.addEventListener('mouseleave', this.switchImage.bind(this, false, img))
        })
    },
    switchImage(showAlt: boolean, item: HTMLImageElement){
      
        const alt = item.dataset.altImg
        const original = item.dataset.original as string       
        if(showAlt && alt){
          item.src = alt
        }else{
            item.src = original
        }
    }
}

export default switchImg